import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { HeartIcon, ShieldCheckIcon, HandshakeIcon, PillIcon, HomeIcon, UserIcon, UsersIcon, ConciergeBellIcon, BrushIcon, CarIcon, ActivityIcon, StethoscopeIcon, AccessibilityIcon, DropletIcon, SyringeIcon, FlaskConicalIcon } from 'lucide-react';
const servicesList = [{
  name: 'Respite Care',
  icon: HeartIcon
}, {
  name: 'Companionship Services',
  icon: HandshakeIcon
}, {
  name: 'Medication Management',
  icon: PillIcon
}, {
  name: 'Homemaking',
  icon: HomeIcon
}, {
  name: 'Personal Care',
  icon: UserIcon
}, {
  name: 'Physical Care',
  icon: ActivityIcon
}, {
  name: 'Occupational Therapy',
  icon: StethoscopeIcon
}, {
  name: 'Physical Therapy',
  icon: AccessibilityIcon
}, {
  name: 'Foley Care',
  icon: DropletIcon
}, {
  name: 'G2 Care',
  icon: SyringeIcon
}, {
  name: 'Infusion Therapy',
  icon: FlaskConicalIcon
}, {
  name: 'Live In / Live Out',
  icon: UsersIcon
}, {
  name: 'Concierge Services',
  icon: ConciergeBellIcon
}, {
  name: 'Light Housekeeping',
  icon: BrushIcon
}, {
  name: 'Transportation & Errands',
  icon: CarIcon
}];
export function AboutSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section id="about" className="py-10 md:py-12 bg-light relative overflow-hidden" data-id="element-27">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" data-id="element-28"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-logo-blue/5 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl" data-id="element-29"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-30">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-31">
          {/* Section Header */}
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-32">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-33">
              About Edvin Home Health Care Solution and Nursing Services
            </h2>
            <div className="w-20 h-1.5 bg-accent mx-auto mb-6 rounded-full" data-id="element-34"></div>
          </div>

          {/* Hero Image */}
          <div className="mb-16 rounded-2xl overflow-hidden shadow-card-hover" data-id="element-35">
            <img src="https://cdn.magicpatterns.com/uploads/2kGX94xbQuji2osUz8iKU6/1.jpg" alt="Caregiver with elderly couple at home" className="w-full h-64 md:h-80 object-cover" data-id="element-36" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-37">
            {/* Content Side */}
            <div data-id="element-38">
              <div className="space-y-6 text-lg text-dark-muted" data-id="element-39">
                <p data-id="element-40">
                  Edvin Home Health Care Solution and Nursing Services provides
                  a wide array of home health personnel services to meet the
                  needs of both the client and family. All services are
                  monitored by a Registered Nurse and designed to assure safe,
                  reliable, and affordable care in the home or residential
                  living facility.
                </p>
                <p data-id="element-41">
                  We utilize pre-employment screening measures to ensure clients
                  are matched with an experienced and compassionate home health
                  aide.
                </p>
              </div>

              {/* RN Monitored Badge */}
              <div className="mt-8 flex items-center bg-primary/5 border border-primary/20 rounded-xl p-5" data-id="element-42">
                <ShieldCheckIcon className="h-10 w-10 text-primary mr-4 flex-shrink-0" data-id="element-43" />
                <div data-id="element-44">
                  <h4 className="font-bold text-dark" data-id="element-45">RN Monitored Care</h4>
                  <p className="text-sm text-dark-muted" data-id="element-46">
                    All services are supervised by a Registered Nurse for your
                    safety and peace of mind.
                  </p>
                </div>
              </div>
            </div>

            {/* Services List Side */}
            <div className="bg-light-alt rounded-2xl p-8 border border-gray-200 shadow-card relative overflow-hidden" data-id="element-47">
              <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
              backgroundImage: 'radial-gradient(circle, #6B9E7A 2px, transparent 2px)',
              backgroundSize: '20px 20px'
            }} data-id="element-48"></div>
              <h3 className="text-xl font-bold text-dark mb-6 relative z-10" data-id="element-49">
                We offer the following services:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 relative z-10" data-id="element-50">
                {servicesList.map((service, idx) => <div key={idx} className="flex items-center space-x-3 p-3 rounded-lg hover:bg-light hover:shadow-sm transition-all group" data-id="element-51">
                    <div className="bg-primary/10 p-2 rounded-lg group-hover:bg-accent transition-colors duration-300 flex-shrink-0" data-id="element-52">
                      <service.icon className="h-5 w-5 text-primary group-hover:text-white transition-colors duration-300" data-id="element-53" />
                    </div>
                    <span className="font-medium text-dark-muted group-hover:text-dark transition-colors" data-id="element-54">
                      {service.name}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}